// ===== Settings (persistent preferences) =====
const KEY = 'scopa.settings.v1';

export const DEFAULT_SETTINGS = {
  accessibleMode: false,
  narrationEnabled: true, // telecronaca on/off (accessible mode, via aria-live)
  soundEnabled: true, // sound effects
  difficulty: 'hard', // opponent AI: 'easy' | 'hard'
};

export function loadSettings() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    const merged = { ...DEFAULT_SETTINGS, ...parsed };
    // Whitelist known keys so legacy settings (e.g. the removed 'narrationVoice'
    // / 'musicEnabled') are dropped and can never re-enable a retired channel.
    const clean = {};
    for (const k of Object.keys(DEFAULT_SETTINGS)) clean[k] = merged[k];
    return clean;
  } catch (e) {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings) {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch (e) {
    /* noop */
  }
}
